export const WEEKDAYS = [
    {value: "1", label: "Segunda"},
    {value: "2", label: "Terça"},
    {value: "3", label: "Quarta"},
    {value: "4", label: "Quinta"},
    {value: "5", label: "Sexta"},
    {value: "6", label: "Sábado"},
    {value: "7", label: "Domingo"},
];

export const HOUR_TYPES = {FIXED: "FIXED", INTERVAL: "INTERVAL", WITHOUT_HOUR: "WITHOUT_HOUR"};

export const emptyHours = () => ({
    type: HOUR_TYPES.FIXED,
    startHour: null,
    startChangeDay: false,
    endHour: null,
    endChangeDay: false,
    allowRepeat: false,
});

export const emptyAddress = () => ({
    place: "",
    type_place: "",
    street: "",
    number: "",
    neighborhood: "",
    crossroads: "",
    reference_point: "",
    city: "",
    latitude: "",
    longitude: "",
});

export const hoursSummary = (hours) => {
    if (!hours) return "";
    if (hours.type === HOUR_TYPES.FIXED) return hours.startHour ?? "";
    if (hours.type === HOUR_TYPES.INTERVAL) return `${hours.startHour ?? ""} - ${hours.endHour ?? ""}`;
    return "Horário livre";
};

export const addressSummary = (address) => {
    if (!address) return "";
    if (address.place) return address.place;
    return [address.neighborhood, address.street, address.number].filter(Boolean).join(" - ");
};

export const hasAddress = (address) =>
    !!(address?.place || address?.neighborhood || address?.street || address?.crossroads);

export const mapAddressFromPayload = (address = {}) => ({
    place: address.place ?? "",
    type_place: address.placeType ?? "",
    street: address.street ?? "",
    number: address.number ?? "",
    neighborhood: address.neighborhood ?? "",
    crossroads: address.crossroad ?? address.crossroads ?? "",
    reference_point: address.referencePoint ?? "",
    city: address.city ?? "",
    latitude: address.latitude ?? "",
    longitude: address.longitude ?? "",
    sectors: address.sectors ?? "",
});

export const buildScheduleModel = ({state, groups, activities, attaches, attachesDescription, addNew, addNewHome}) => {
    const attachesWithDescription = (attaches ?? []).map(file => ({
        ...file,
        name: file.name,
        attachId: file.attachId,
        description: attachesDescription?.[file.attachId] ?? file.description ?? "",
    }));

    const attachmentDescription = attachesWithDescription
        .filter(file => file.new)
        .map(file => ({name: file.name, description: file.description}))
        .filter(item => item.description);

    const attachment = attachesWithDescription.filter(file => !file.new);

    const group = {
        teams: groups.teams,
        intendedFunctions: groups.intendedFunctions,
        sectors: groups.sectors,
        weekdays: groups.weekdays,
    };

    const activitiesPayload = activities.map(activity => ({
        itemId: activity.itemId,
        hours: activity.hours,
        duration: activity.duration || null,
        priority: activity.priority || null,
        reason: activity.reason || null,
        description: activity.description || null,
        address: {
            place: activity.address.place || null,
            placeType: activity.address.type_place || null,
            street: activity.address.street || null,
            number: activity.address.number || null,
            neighborhood: activity.address.neighborhood || null,
            crossroad: activity.address.crossroads || null,
            referencePoint: activity.address.reference_point || null,
            city: activity.address.city || null,
            latitude: activity.address.latitude || null,
            longitude: activity.address.longitude || null,
            sectors: activity.address.sectors || null,
        },
    }));

    return {
        id: state.id || null,
        systemUpdate: state.systemUpdate || null,
        addNew,
        addNewHome,
        name: state.name || null,
        dateUsageMin: state.dateUsageMin || null,
        dateUsageMax: state.dateUsageMax || null,
        description: state.description ?? null,
        inactive: state.inactive,
        inactiveObservation: state.inactive ? (state.inactiveObservation ?? null) : null,
        groups: group,
        autoApplyByGroup: groups.autoApply,
        activities: activitiesPayload,
        attachment,
        attachmentDescription: attachmentDescription.length ? attachmentDescription : null,
    };
};
